// extracted by mini-css-extract-plugin
export default {"DocumentList":"DocumentList_DocumentList__RWTlJ","name":"DocumentList_name__4gA1v","object":"DocumentList_object__jYBF8","type":"DocumentList_type__AXsWR"};